import type { ReactNode } from "react"

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@coval/ui"
import { X } from "lucide-react"

export function SqlConversationPickerDialog({
  children,
  onClose,
}: {
  children: ReactNode
  onClose: () => void
}) {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) {
          onClose()
        }
      }}
    >
      <DialogContent
        size="lg"
        className="h-[min(640px,85vh)] w-[calc(100vw-32px)] max-w-5xl gap-4 overflow-hidden p-5"
      >
        <DialogHeader className="p-0 pr-8">
          <DialogTitle>Select Conversation</DialogTitle>
          <DialogDescription>
            Choose a row to preview its audio and test this metric.
          </DialogDescription>
        </DialogHeader>
        <DialogClose asChild>
          <Button
            variant="ghost"
            icon
            tooltip={null}
            aria-label="Close conversation picker"
            className="absolute right-3 top-3"
          >
            <X />
          </Button>
        </DialogClose>
        {children}
      </DialogContent>
    </Dialog>
  )
}
